"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Dollar` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Dollar = createSVGIcon(
  <>
    <path
      d="M.5 12.5a12 12 0 1 0 24 0 12 12 0 0 0-24 0Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.051 20.001a.498.498 0 0 0 .996 0v-1.645c2.194-.136 3.764-1.62 3.764-3.545 0-2.177-1.283-2.97-3.764-3.409v-4.22c1.063.144 1.722.655 2.051 1.604.106.307.377.54.701.54.405 0 .725-.355.614-.744-.428-1.504-1.613-2.386-3.366-2.547V4.997a.498.498 0 1 0-.996 0v1.021C9.941 6.153 8.49 7.52 8.49 9.275c0 2.026 1.333 2.819 3.561 3.24v4.693c-1.729-.156-2.292-1.002-2.528-2.049-.078-.35-.373-.618-.732-.618-.423 0-.758.368-.662.78.374 1.592 1.432 2.86 3.922 3.035zM9.823 9.141c0-1.047.81-1.857 2.228-1.975v4.067c-1.873-.388-2.228-1.03-2.228-2.093m5.587 5.772c0 1.249-1.013 2.16-2.363 2.295v-4.523c1.84.388 2.363.979 2.363 2.227"
      fill="currentColor"
    />
  </>,
  "Dollar",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    color: Core.icon.default,
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
